import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import codeBidiWarningDecorator from '@atlaskit/code/bidi-warning-decorator';
import { pluginFactory, stepHasSlice } from '@atlaskit/editor-common/utils';
import { DOMSerializer } from '@atlaskit/editor-prosemirror/model';
import { Decoration, DecorationSet } from '@atlaskit/editor-prosemirror/view';
import { getCodeBidiWarningDomSpec } from './codeBidiWarningDomSpec';
import { codeBidiWarningPluginKey } from './plugin-key';
import reducer from './reducer';
export var pluginFactoryCreator = function pluginFactoryCreator() {
  return pluginFactory(codeBidiWarningPluginKey, reducer, {
    onDocChanged: function onDocChanged(tr, pluginState) {
      if (!tr.steps.find(stepHasSlice)) {
        return pluginState;
      }
      var newBidiWarningsDecorationSet = createBidiWarningsDecorationSetFromDoc({
        doc: tr.doc,
        codeBidiWarningLabel: pluginState.codeBidiWarningLabel,
        tooltipEnabled: pluginState.tooltipEnabled
      });
      return _objectSpread(_objectSpread({}, pluginState), {}, {
        decorationSet: newBidiWarningsDecorationSet
      });
    }
  });
};
export function createBidiWarningsDecorationSetFromDoc(_ref) {
  var doc = _ref.doc,
    codeBidiWarningLabel = _ref.codeBidiWarningLabel,
    tooltipEnabled = _ref.tooltipEnabled;
  var bidiCharactersAndTheirPositions = [];
  doc.descendants(function (node, pos) {
    var isTextWithCodeMark = node.type.name === 'text' && node.marks && node.marks.some(function (mark) {
      return mark.type.name === 'code';
    });
    if (isTextWithCodeMark) {
      codeBidiWarningDecorator(node.textContent, function (_ref2) {
        var bidiCharacter = _ref2.bidiCharacter,
          index = _ref2.index;
        bidiCharactersAndTheirPositions.push({
          // Ignored via go/ees005
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          position: pos + index,
          bidiCharacter: bidiCharacter
        });
      });
      return false;
    }
    var isCodeBlock = node.type.name === 'codeBlock';
    if (isCodeBlock) {
      codeBidiWarningDecorator(node.textContent, function (_ref3) {
        var bidiCharacter = _ref3.bidiCharacter,
          index = _ref3.index;
        bidiCharactersAndTheirPositions.push({
          // Ignored via go/ees005
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          position: pos + index + 1,
          bidiCharacter: bidiCharacter
        });
      });
    }
  });

  // Bidi characters are not expected to commonly appear in code snippets, so recreating the decoration set
  // for documents rather than reusing existing decorations seems a reasonable performance/complexity tradeoff.

  if (bidiCharactersAndTheirPositions.length === 0) {
    return DecorationSet.empty;
  }
  var newBidiWarningsDecorationSet = DecorationSet.create(doc, bidiCharactersAndTheirPositions.map(function (_ref4) {
    var position = _ref4.position,
      bidiCharacter = _ref4.bidiCharacter;
    return Decoration.widget(position, function (el) {
      return renderDOM(bidiCharacter, codeBidiWarningLabel, tooltipEnabled);
    }, {
      destroy: function destroy(el) {
        if (!(el instanceof HTMLElement)) {
          throw new Error('Code Bidi Warning DOM spec did not return an HTMLElement');
        }
        el.remove();
      }
    });
  }));
  return newBidiWarningsDecorationSet;
}
function renderDOM(bidiCharacter, codeBidiWarningLabel, tooltipEnabled) {
  var spec = getCodeBidiWarningDomSpec(bidiCharacter, codeBidiWarningLabel, tooltipEnabled);
  var _DOMSerializer$render = DOMSerializer.renderSpec(document, spec),
    dom = _DOMSerializer$render.dom;
  if (!(dom instanceof HTMLElement)) {
    throw new Error('Code Bidi Warning DOM spec did not return an HTMLElement');
  }
  return dom;
}